import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { FaRegFileLines } from 'react-icons/fa6';
import SalaryAdditions from "./index";
import ViewSalaryAddition from "./view";
import EditSalaryAddition from "./edit";
import { MODULE_SAL_ADDITIONS } from "variables/constants";

const salaryAdditionRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Salary Additions",
		basePath: "salary-additions",
		mainComponent: <SalaryAdditions />,
	    layout: "/console",	   
	    icon: <FaRegFileLines className="icon-item" />,
	    subTitle:"Salary Addition",
	    viewComponent: <ViewSalaryAddition />,
	    createComponent: <EditSalaryAddition />,
	    editComponent: <EditSalaryAddition />,
		level:3,
		moduleId: MODULE_SAL_ADDITIONS,
	})
]

export default salaryAdditionRoutes;